import React from "react";

// Shared star rating display/input — replaces three previous ad hoc
// implementations (raw "★".repeat() text, a bare ⭐ emoji + number, and a
// clickable <span> array) with one consistent component.
const StarRating = ({ value = 0, outOf = 5, size, interactive = false, onChange }) => {
  const stars = Array.from({ length: outOf }, (_, i) => i + 1);

  return (
    <span className="star-rating" style={size ? { fontSize: size } : undefined}>
      {stars.map((star) => (
        <span
          key={star}
          className={`star-rating-item ${star <= Math.round(value) ? "on" : ""} ${interactive ? "interactive" : ""}`}
          onClick={interactive ? () => onChange && onChange(star) : undefined}
        >
          {star <= Math.round(value) ? "★" : "☆"}
        </span>
      ))}
    </span>
  );
};

export default StarRating;
